import { secaucusConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function SecaucusPage() {
  return <CityPageTemplate config={secaucusConfig} />;
}